import React, { useEffect } from "react";

export const Loader = () => {
    useEffect(() => {
    }, []);
    return (<div className="loader-container">
        <div className="spinner"></div>
        <div className="loading-text">Loading</div>
    </div>);
};